export default () => ({
  list: {},
  tree: [],
  expanded: [],
  added: null,
  selected: null,
  lastLoad: false
})
